export default "__VITE_ASSET__YO7WtGxx__"